import axios from 'axios'

export default class EmailArea {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/email`
    this.tokenBearer = tokenBearer
  }

  async getBuscarEmails (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/consulta?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getExportarArquivo (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/exportar?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob'
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putReenviarEmails (data) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url: `${this.url}/reenviar`,
        headers: {
          'Authorization': this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async putReenviarPendente (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url: `${this.url}/reenviarSelecionados?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }
      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getStatus () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/status`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getValidar (hash) {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/validar/${hash}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
